(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
    if (!event.target.closest?.('[data-dd-product-preview-link]')) return;

    const panel = document.getElementById('dilly-ai-preview');
    if (panel?.matches('details[data-dd-preview-shell]')) {
      panel.open = true;
      panel.querySelector('summary')?.focus({ preventScroll: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-holiday-feature"] && !Shopify.designMode) return;
  try {
    
(() => {
  let timer;
  function refreshHolidayFeature() {
    clearTimeout(timer);
    let nextCheck = Infinity;
    for (const feature of document.querySelectorAll('[data-dd-holiday-expires-at]')) {
      const remaining = Number(feature.dataset.ddHolidayExpiresAt) - Date.now();
      if (remaining <= 0) {
        const wrapper = feature.closest('.shopify-section') || feature;
        wrapper.hidden = true;
        wrapper.style.setProperty('display', 'none', 'important');
      } else if (Number.isFinite(remaining)) {
        nextCheck = Math.min(nextCheck, remaining);
      }
    }
    if (Number.isFinite(nextCheck)) timer = setTimeout(refreshHolidayFeature, Math.min(nextCheck, 86400000));
  }
  refreshHolidayFeature();
  window.addEventListener('pageshow', refreshHolidayFeature);
  document.addEventListener('visibilitychange', refreshHolidayFeature);
  document.addEventListener('shopify:section:load', refreshHolidayFeature);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-watercolor-portrait"] && !Shopify.designMode) return;
  try {
    
function initWatercolorPortraits(){
  document.querySelectorAll('[data-watercolor-section]').forEach(root=>{
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const main=root.querySelector('.dd-wc-main-image');
    const dialog=root.querySelector('[data-portrait-dialog]');
    const open=root.querySelector('[data-open-portrait]');
    const thumbs=[...root.querySelectorAll('[data-portrait-image]')];
    const select=root.querySelector('[data-portrait-variant]');
    const add=root.querySelector('[data-portrait-add]');
    const file=root.querySelector('[data-portrait-file]');
    const error=root.querySelector('[data-file-error]');
    function showImage(src,alt){main.removeAttribute('srcset');main.src=src;main.alt=alt;}
    thumbs.forEach(button=>button.addEventListener('click',()=>{showImage(button.dataset.portraitImage,button.dataset.imageAlt);thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t===button)));}));
    let lightboxTrigger=open;
    function openLightbox(src,alt,trigger){lightboxTrigger=trigger;const image=dialog.querySelector('img');image.src=src;image.alt=alt;dialog.showModal();}
    open.addEventListener('click',()=>openLightbox(main.src,main.alt,open));
    root.querySelectorAll('[data-open-example]').forEach(button=>button.addEventListener('click',()=>openLightbox(button.dataset.openExample,button.dataset.exampleAlt,button)));
    root.querySelector('[data-close-portrait]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
    dialog.addEventListener('close',()=>lightboxTrigger.focus());
    select.addEventListener('change',()=>{const option=select.selectedOptions[0];root.querySelector('[data-portrait-price]').textContent=option.dataset.price;add.disabled=root.dataset.launchEnabled!=='true'||option.dataset.available!=='true';if(option.dataset.image){const matching=thumbs.find(t=>t.dataset.portraitImage===option.dataset.image);showImage(option.dataset.image,matching?matching.dataset.imageAlt:option.textContent);thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t===matching)));}});
    file.addEventListener('change',()=>{const image=file.files[0];const invalid=Boolean(image&&(image.size>20*1024*1024||!['image/jpeg','image/png','image/webp'].includes(image.type)));error.hidden=!invalid;file.setCustomValidity(invalid?error.textContent:'');});
    root.querySelector('form').addEventListener('submit',event=>{if(root.dataset.launchEnabled!=='true'){event.preventDefault();return;}if(!file.files.length){event.preventDefault();file.reportValidity();}});
    root.querySelectorAll('[data-example]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-example]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-example-pair]').forEach(pair=>pair.hidden=pair.dataset.examplePair!==button.dataset.example);}));
  });
}
initWatercolorPortraits();
document.addEventListener('shopify:section:load',initWatercolorPortraits);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  class DillyFooterLinks extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.updateLayout = () => { this.details.open = !this.mobileQuery.matches; };
      this.updateLayout();
      this.mobileQuery.addEventListener('change', this.updateLayout);
    }

    disconnectedCallback() {
      this.mobileQuery.removeEventListener('change', this.updateLayout);
    }
  }

  customElements.define('dd-footer-links', DillyFooterLinks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header') || this;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
